import { render, staticRenderFns } from "./TicketLocationForm.vue?vue&type=template&id=10633848&"
import script from "./TicketLocationForm.vue?vue&type=script&lang=ts&"
export * from "./TicketLocationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports